import { css } from '@emotion/react';

import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import ImageViewer from 'components/field/ImageViewer';
import Timeline, { TimelineItem } from 'components/global/Timeline';
import Typography from 'components/global/Typography';
import { Video } from 'components/global/Video';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

const LinkButton = ({ children }) => {
	const { t } = useTranslation();
	return (
		<Button component="a" href={children} variant="outline" rel="noopener noreferrer" target="_blank">
			{t(children)}
		</Button>
	);
};

const LinkViewer = ({ children }) => {
	const { t } = useTranslation();
	return (
		<a href={children} rel="noopener noreferrer" target="_blank">
			{t(children)}
		</a>
	);
};

const VideoViewer = ({ children, formName }) => {
	const isMobile = useMediaQuery(Breakpoints.mobile);
	return (
		<Video
			controls
			logo="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
			title={`${formName}.videoTitle`}
			variant="inline"
			videoId={Array.isArray(children) ? children[0].split('=')[1] : children}
			width={isMobile ? '100%' : '35rem'}
			height={isMobile ? '100%' : '20rem'}
		/>
	);
};

const StyledSpan = ({ children }) => {
	return <span>{children}</span>;
};

const StyledLi = ({ children }) => {
	return <li>{children}</li>;
};

const StyledUl = ({ children }) => {
	return <ul>{children}</ul>;
};

const SalesChannelsInstructions = ({ instructions }) => {
	const { salesChannel } = useSelector((state) => state.salesChannel);
	const { i18n } = useTranslation();
	return (
		<Timeline className="instructions" hasNumber>
			{instructions?.map((stepKey, index) => (
				<TimelineItem
					key={`instructions-${i18n.language}-${index + 1}`}
					alignment="left"
					lineNumber={index + 1}
					isLastItem={index === instructions.length - 1}
					itemCss={css({
						minHeight: '9rem',
						gap: '2rem',
						lineHeight: '2.4rem'
					})}>
					<Typography
						component="div"
						variant="p3"
						noWrap
						fontWeight="500"
						css={css({
							p: {
								margin: 0
							}
						})}>
						<Trans
							i18nKey={stepKey}
							components={{
								linkViewer: <LinkViewer />,
								image: <ImageViewer />,
								videoViewer: <VideoViewer formName={salesChannel?.slug} />,
								button: <LinkButton />,
								pre: <pre />,
								code: <code />,
								span: <StyledSpan />,
								ul: <StyledUl />,
								li: <StyledLi />
							}}
						/>
					</Typography>
				</TimelineItem>
			))}
		</Timeline>
	);
};

export default SalesChannelsInstructions;
